import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
  signal,
} from '@angular/core';
import { OrdenesService } from '../../utilidades/ordenes.service';
import { CONFIGURACION_FORMULARIO_FORMULA } from './utilidades/datos-formula.static';
import { deepCopy } from 'src/app/compartido/utilidades/objetos.utils';
import { ConfiguracionFormulario } from 'src/app/compartido/formulario/utilidades/formulario.models';
import { AlertasService } from 'src/app/nucleo/utilidades/alertas.service';
import { ErrorFrontend } from 'src/app/compartido/utilidades/error.utils';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { FormularioModule } from 'src/app/compartido/formulario/formulario.module';
import { CommonModule } from '@angular/common';
import { FormulaDTO } from '../../utilidades/ordenes.models';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'ordenes-datos-formula',
  templateUrl: './datos-formula.component.html',
  styleUrls: ['./datos-formula.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    MatIconModule,
    MatButtonModule,
    FormularioModule,
    CommonModule,
    MatProgressSpinnerModule,
  ],
})
export class DatosFormulaComponent implements OnInit {
  /* ID de la fórmula */
  @Input({ required: true }) public idFormula!: number;

  /* Fórmula */
  protected formula: FormulaDTO | undefined;

  /* Estado de edición */
  protected editar = signal<boolean>(false);

  /* Estado de carga */
  protected cargando = signal<boolean>(true);

  /* Formulario */
  protected configFormulario: ConfiguracionFormulario = deepCopy(
    CONFIGURACION_FORMULARIO_FORMULA,
  );

  constructor(
    private readonly _ordenesService: OrdenesService,
    private readonly _alertasService: AlertasService,
    private readonly _cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.cargando.set(true);

    // Obtener la orden
    this._ordenesService
      .obtenerFormula$(this.idFormula)
      .then((formula: FormulaDTO) => {
        // Asignar la fórmula
        this.formula = formula;

        // Configurar el formulario
        const datos = this.formula as Record<string, any>;
        for (const campo of this.configFormulario.campos) {
          campo.valor = datos[campo.slug];
        }

        this.cargando.set(false);
        this._cdr.markForCheck();
      })
      .catch((error: ErrorFrontend) => {
        this._alertasService.alertarError('Error: ' + error.message);
        this.cargando.set(false);
      });

    // Actualizar el estado de edición
    this.desactivarEdicion();
  }

  /**
   * Desactiva el modo de edición del formulario.
   * @author Juan Corral
   */
  protected desactivarEdicion(): void {
    this.editar.set(false);
    this.configFormulario.campos.forEach((campo) => (campo.readonly = true));
    this._cdr.markForCheck();
  }
}
